window.addEventListener('DOMContentLoaded', (event) => {
  $(".btn_wraper button").click((function() {
        $(".question:nth-child(n+6)").toggle();  
        var i = $(this);
        "See Less Faq's" === i.html() ? ($(".question:nth-child(5)").css("opacity", "0.4"), $(".question:nth-child(5) > .faqs_accordion").attr("disabled", "disabled"), i.html("See More Faq's")) : ($(".question:nth-child(5)").css("opacity", "1"), $(".question:nth-child(5) > .faqs_accordion").removeAttr("disabled"), i.html("See Less Faq's"))
    }))
  
    var swiper2 = new Swiper(".thumnail-images-slider", {
        direction: "vertical",
        autoHeight: true,
        pagination: false,
        slidesPerView: 6,
    });
    var swiper = new Swiper(".main-images-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: '.images-sliders .swiper-pagination',
            clickable: true,
        },
        thumbs: {
        swiper: swiper2,
        },
    });
    setTimeout(function(){
        $('.media-placeholder').hide();
    },1000);
    $(document).on('click','.main-images-slider img',function(){

          var currentImgClicked=$(this).attr('src');
          if($(window).width() > 1024){
            var variants="";
            var images='<div class="swiper-slide"><div class="goOnZoom" style="background-image:url('+currentImgClicked+')" onmousemove="zoom(event)" ontouchmove="zoom(event)"><img src="'+currentImgClicked+'"></div></div>';
            $('.media-img-hidden').each(function(){
              var imgTemp=$(this).data("src");
              if(imgTemp != currentImgClicked){
                images+='<div class="swiper-slide"><div class="goOnZoom" style="background-image:url('+imgTemp+')" onmousemove="zoom(event)" ontouchmove="zoom(event)"><img src="'+imgTemp+'"></div></div>';
              }
            });
            $('.product-popup-gallery').html('<div class="images-sliders"><div class="swiper popup-main-images-slider"><div class="swiper-wrapper">'+images+'</div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div><div class="swiper popup-thumnail-images-slider"><div class="swiper-wrapper">'+images+'</div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div></div>');
            var swiper2 = new Swiper(".popup-thumnail-images-slider", {
              autoHeight: true,
              slidesPerView: 6,
              watchOverflow: true,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,
              direction: 'vertical'
            });
            var swiper = new Swiper(".popup-main-images-slider", {
              watchOverflow: true,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,
              preventInteractionOnTransition: true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              thumbs: {
                swiper: swiper2
              }
            });
          }else{
              var img=$(this).attr('src');
              $('.product-popup-gallery').html('<div class="pinch-zoom" ><img src="'+img+'"></div>');
              $('.product-popup-gallery').addClass('mobile-gallery');
              var el = document.querySelector('div.pinch-zoom');
              new PinchZoom.default(el, {});    
          }
          $('.product-images-popup').fadeIn();
          $('.product-images-popup').addClass('active');
        });
    $('.close-popup').click(function(){
        $('.product-images-popup').fadeOut();
    });
    $(document).keyup(function(e){
        if($('.product-images-popup').hasClass('active') && e.key == "Escape"){
            $('.product-images-popup').fadeOut();
            $('.product-images-popup').removeClass('active');
        }
    });
});